import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { DashboardService } from '../services/dashboard.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

  breadCrumbItems!: Array<{}>;

  constructor(private modalService: NgbModal, private changeDetector: ChangeDetectorRef,
    private router: Router, private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService, public authService: AuthenticationService) {

  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Inicio', active: true }
    ];

  }

}
